export const NOT_INVITED = "NOT_INVITED";